import Api from './api';

export default {
  getIssues: async ({ commit, dispatch }, { projectId, recordingId }) => {
    commit('setIssuesStatus', 'Fetching');
    if (!projectId && !recordingId) return;
    try {
      const res = await Api.getIssues({ projectId, recordingId });
      commit('setIssues', res.data);
      commit('setIssuesStatus', 'Fetched');
    } catch (err) {
      if (err.response && err.response.status === 403) {
        dispatch('users/logout', {}, { root: true });
      }
      commit('setIssuesErrMessage', err.message);
    }
  },
  clear({ commit }) {
    commit('CLEAR');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/issues/actions.js